import React from 'react';
import { observer } from 'mobx-react';
import { PlusCircleOutlined } from '@ant-design/icons';

import { i18n } from 'core/localization';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput, AntTextArea } from 'controls/react/ant/antInput';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { AntButton } from 'controls/react/ant/antButton';
import { fromIdName } from 'controls/react/ant/ant-select/utils/fromIdName';
import { TagsSelect } from 'controls/react/tagsSelect';
import { TimeZoneSelector } from 'controls/react/TimeZoneSelector';
import { CreateServiceFormProps } from './types';

export const CreateServiceForm = observer(({ store }: CreateServiceFormProps) => {
	const { model, validator } = store;

	return (
		<Section appearance={'none'} contentPadding={true} childrenPadding={true}>
			<FormEntryNew label={i18n('Name')} model={model} modelField={'name'} validator={validator}>
				<AntInput autoFocus={true} />
			</FormEntryNew>
			<FormEntryNew label={i18n('Description')} model={model} modelField={'description'}>
				<AntTextArea autoSize={{ minRows: 2, maxRows: 5 }} />
			</FormEntryNew>
			<FormEntryNew label={i18n('Team')} model={model} modelField={'teamIds'} validator={validator}>
				<AntSelect
					mode={'multiple'}
					allowClear={true}
					sortValues={true}
					showSearch={{ optionFilterProp: 'label' }}
					options={fromIdName(store.teams)}
					loading={store.loading}
				/>
				{store.canCreateTeam && (
					<AntButton
						type={'text'}
						icon={<PlusCircleOutlined />}
						title={i18n('Create team')}
						onClick={store.openTeamForm}
					/>
				)}
			</FormEntryNew>
			<FormEntryNew label={i18n('Information')} model={model} modelField={'information'}>
				<AntTextArea autoSize={{ minRows: 2, maxRows: 5 }} />
			</FormEntryNew>
			<FormEntryNew label={i18n('Tags')} model={model} modelField={'tags'}>
				<TagsSelect accountId={store.accountId} />
			</FormEntryNew>
			<FormEntryNew label={i18n('Time Zone')} model={model} modelField={'timeZone'}>
				<TimeZoneSelector />
			</FormEntryNew>
		</Section>
	);
});
